exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n/* Fixed the z-index of dropdown inside buttons */\n.btn[data-v-edf95418] {\n    will-change: auto;\n}\n.btn-dropdown[data-v-edf95418] {\n    top: 0px;\n    left: 0px;\n    width: 20px;\n    height: 15px;\n}\n.btn-actions[data-v-edf95418] {\n    position: absolute;\n    top:0;\n    width:100%;\n    height:15px;\n}\n.btn .dropdown-item[data-v-edf95418] {\n    text-transform: none;\n}\n.btn .dropdown-item[data-v-edf95418]:hover {\n    color: #fff;\n}\n\n", ""]);

// exports
